export const Gender = {
  male: 0,
  female: 1,
  other: 2,
};
